import { Get } from "./helpers";

export function GetChannelEvents(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/events`, token);
}

export function GetChannelDeviceTypes(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/deviceTypes`, token);
}

export function GetChannelBrowsers(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/browsers`, token);
}

export function GetChannelAudience(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/audience`, token);
}

export function GetChannelRegistrations(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/registrations`, token);
}

export function GetChannelDurations(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/averageDuration`, token);
}

export function GetChannelViews(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/views`, token);
}

export function GetChannelWatchtime(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/watchtime`, token);
}

export function GetChannelRetentionAverage(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/retention/average`, token);
}

export function GetChannelRetentionBuckets(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/retention/buckets`, token);
}

export function GetChannelRegions(channel: number, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/channels/${channel}/regions`, token);
}

export function GetEventDeviceTypes(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/deviceTypes`, token);
}
export function GetEventRegions(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/regions`, token);
}
export function GetEventLanguages(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/languages`, token);
}
export function GetEventViews(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/views`, token);
}
export function GetEventDuration(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/averageDuration`, token);
}
export function GetEventRetentionAverage(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/retention/average`, token);
}
export function GetEventRetentionBuckets(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/retention/buckets`, token);
}
export function GetEventRegistrations(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/registrations`, token);
}
export function GetEventEmails(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/emails`, token);
}
export function GetEventWatchtime(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/watchtime`, token);
}
export function GetEventBrowsers(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/browsers`, token);
}
export function GetEventSessions(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/sessions`, token);
}
export function GetEventMapData(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/events/${uuid}/countryMap`, token);
}

export function GetSessionDeviceTypes(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/deviceTypes`, token);
}
export function GetSessionRegions(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/regions`, token);
}
export function GetSessionLanguages(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/languages`, token);
}
export function GetSessionViews(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/views`, token);
}
export function GetSessionDuration(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/averageDuration`, token);
}
export function GetSessionRetentionAverage(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/retention/average`, token);
}
export function GetSessionRegistrations(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/registrations`, token);
}
export function GetSessionEmails(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/emails`, token);
}
export function GetSessionWatchtime(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/watchtime`, token);
}
export function GetSessionBrowsers(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/browsers`, token);
}
export function GetSessionTimeline(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/timeline`, token);
}
export function GetSessionMapData(uuid: string, token: string): Promise<any> {
	return Get(`/v3/admin/metrics/sessions/${uuid}/countryMap`, token);
}